<template>
    <svg width="16px" height="18px" viewBox="0 0 16 18" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg">
        <g id="iconPause" transform="translate(-8 -7)">
            <path
                d="M9 7L13 7C13.5523 7 14 7.44772 14 8L14 24C14 24.5523 13.5523 25 13 25L9 25C8.44772 25 8 24.5523 8 24L8 8C8 7.44772 8.44772 7 9 7ZM19 7L23 7C23.5523 7 24 7.44772 24 8L24 24C24 24.5523 23.5523 25 23 25L19 25C18.4477 25 18 24.5523 18 24L18 8C18 7.44772 18.4477 7 19 7Z"
                id="Shape" fill-rule="evenodd" stroke="none" />
        </g>
    </svg>
</template>